// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

export const firebaseConfig = {
  apiKey: "AIzaSyDxqyPDxgKfEWHEUx1ONc9MEqfnUsLa8Dg",
  authDomain: "jabuzwane-56039.firebaseapp.com",
  projectId: "jabuzwane-56039",
  storageBucket: "jabuzwane-56039.firebasestorage.app",
  messagingSenderId: "776255578692",
  appId: "1:776255578692:web:0799bb02f4c1dc4e415211",
  measurementId: "G-HV4GWBVTV8"
};

const app = initializeApp(firebaseConfig);

export const db   = getFirestore(app);
export const auth = getAuth(app);